/**
 * Zone equipment mode (ROS Region.msg cleaning_type).
 * Sweeper=1, Scrubber=3, Combo=2. No Unknown.
 */
export enum CleaningTypeEnum {
  SWEEPER = 'Sweeper',
  SCRUBBER = 'Scrubber',
  COMBO = 'Combo',
}

/** Default value when creating/displaying a zone. */
export const CLEANING_TYPE_DEFAULT = CleaningTypeEnum.SWEEPER

/** Mapping label → backend cleaning_type (number). */
export const CLEANING_TYPE_TO_NUMBER: Record<CleaningTypeEnum, number> = {
  [CleaningTypeEnum.SWEEPER]: 1,
  [CleaningTypeEnum.COMBO]: 2,
  [CleaningTypeEnum.SCRUBBER]: 3,
}

/** Mapping backend cleaning_type (number) → label. */
export const CLEANING_TYPE_FROM_NUMBER: Record<number, CleaningTypeEnum> = {
  1: CleaningTypeEnum.SWEEPER,
  2: CleaningTypeEnum.COMBO,
  3: CleaningTypeEnum.SCRUBBER,
}
